import React from 'react'
import setTextColorWithBackground from 'bam-node-baseball-savant/utils/set-text-color-with-background.ts'
import { colorScale } from 'bam-node-baseball-savant/utils/percentile-colors.ts'
import type { Filter, PercentileOption } from './types.ts'
import { ComparatorDict } from './types.ts'

type FilterPillProps = {
    filter: Filter
    options: PercentileOption[]
}

export default function FilterPills({ filter, options }: FilterPillProps) {
    const { prop, comparator, val } = filter

    const option = options.find((o) => o.value === prop)

    if (!option) {
        return null
    }

    const backgroundColor = colorScale(val)
    const textColor = setTextColorWithBackground(backgroundColor)

    return (
        <div
            style={{
                backgroundColor,
                display: 'inline-block',
                padding: '5px 10px',
                borderRadius: '14px',
                color: textColor,
                border: '0.5px solid #666',
            }}
        >
            {option.label} {ComparatorDict[comparator]} {val}
        </div>
    )
}
